import React, {useEffect, useState} from "react";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../common/Loading";
import {Grid} from "@mui/material";
import {useReservationAPI} from "../../service/useReservationAPI";
import {useSearchParams} from "react-router-dom";
import ReservationPaid from "./feedback/ReservationPaid";
import ReservationPaymentFailed from "./feedback/ReservationPaymentFailed";
import ReservationPaymentCanceled from "./feedback/ReservationPaymentCanceled";
import ReservationProcessing from "./feedback/ReservationProcessing";
import ReservationPaymentOpen from "./feedback/ReservationPaymentOpen";
import AppSnackbar from "../../common/AppSnackbar";
import {useTranslation} from "react-i18next";

function PaymentProcessor() {
    const { t } = useTranslation();
    const {checkPaymentStatus} = useReservationAPI();
    const [searchParams] = useSearchParams();
    const [paymentStatus, setPaymentStatus] = useState("")

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    function handleFetchError(reason) {
        setSnackbarMessage(reason)
        setOpenSnackbar(true)
    }

    useEffect(() => {
        checkPaymentStatus(searchParams.get('reservation_id') || searchParams.get('appointment_id') )
            .then(value => setPaymentStatus(value))
            .catch(() => handleFetchError(t('paymentStatusFetchFailed')) );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // TODO error handeling
    //     CANCELED, OK
    //     EXPIRED, -> Customer does not return to the site --> not to catch
    //     FAILED,
    //     PAID

    return (
        <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{textAlign: 'center'}}>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                {paymentStatus === '' && (<ReservationProcessing/>)}
                {paymentStatus === 'paid' && (<ReservationPaid/>)}
                {paymentStatus === 'open' && (<ReservationPaymentOpen/>)}
                {paymentStatus === 'failed' && (<ReservationPaymentFailed/>)}
                {paymentStatus === 'canceled' && (<ReservationPaymentCanceled/>)}
            </Grid>
            <AppSnackbar openSnackbar={openSnackbar} snackbarMessage={snackbarMessage} setOpenSnackbar={setOpenSnackbar} />
        </Grid>
    )
}


export default withAuthenticationRequired(PaymentProcessor, {
    onRedirecting: () => <Loading/>,
    returnTo: '/payment-processor'
});
